/** Price of the My Bestie service in EUR. */
export const MY_BESTIE_PRICE_EUR = 50;
